module.exports = __webpack_public_path__ + "img/ring_y_l_0_0.01016188.png";